// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 获取当前用户信息 通过Token返回当前登录用户信息 GET /smart-tea/v1.0/auth/sa/info-by-token */
export async function getUserInfoByTokenUsingGet(options?: {
  [key: string]: any;
}) {
  return request<STearAPI.ResponseDataUserBaseInfo>(
    "/smart-tea/v1.0/auth/sa/info-by-token",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 手机号登录 通过手机号和验证码登录 POST /smart-tea/v1.0/auth/sa/login/phone */
export async function loginWithPhoneUsingPost(
  body: STearAPI.PhoneLoginRequest,
  options?: { [key: string]: any }
) {
  return request<STearAPI.ResponseDataLoginResponse>(
    "/smart-tea/v1.0/auth/sa/login/phone",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 用户名登录 通过用户名和密码登录 POST /smart-tea/v1.0/auth/sa/login/username */
export async function loginWithUsernameUsingPost(
  body: STearAPI.UsernameLoginRequest,
  options?: { [key: string]: any }
) {
  return request<STearAPI.ResponseDataLoginResponse>(
    "/smart-tea/v1.0/auth/sa/login/username",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 微信登录 通过微信小程序code登录 POST /smart-tea/v1.0/auth/sa/login/wechat */
export async function loginWithWechatUsingPost(
  body: STearAPI.WechatLoginRequest,
  options?: { [key: string]: any }
) {
  return request<STearAPI.ResponseDataLoginResponse>(
    "/smart-tea/v1.0/auth/sa/login/wechat",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 微信小程序登录测试接口(通过unionid获取token) POST /smart-tea/v1.0/auth/sa/login/wechat/by-unionid/${param0} */
export async function loginWithWechatByUnionidUsingPost(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: STearAPI.loginWithWechatByUnionidUsingPostParams,
  options?: { [key: string]: any }
) {
  const { unionid: param0, ...queryParams } = params;
  return request<STearAPI.ResponseDataLoginResponse>(
    `/smart-tea/v1.0/auth/sa/login/wechat/by-unionid/${param0}`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 登出 退出登录 POST /smart-tea/v1.0/auth/sa/logout */
export async function logoutUsingPost(options?: { [key: string]: any }) {
  return request<STearAPI.ResponseDataVoid>("/smart-tea/v1.0/auth/sa/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 用户注册 注册新用户 POST /smart-tea/v1.0/auth/sa/register */
export async function registerUsingPost(
  body: STearAPI.RegisterRequest,
  options?: { [key: string]: any }
) {
  return request<STearAPI.ResponseDataUserBaseInfo>(
    "/smart-tea/v1.0/auth/sa/register",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 发送验证码 发送短信验证码 POST /smart-tea/v1.0/auth/sa/sms/send */
export async function sendSmsCodeUsingPost(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: STearAPI.sendSmsCodeUsingPostParams,
  options?: { [key: string]: any }
) {
  return request<STearAPI.ResponseDataVoid>(
    "/smart-tea/v1.0/auth/sa/sms/send",
    {
      method: "POST",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 GET /smart-tea/v1.0/auth/sa/test-token */
export async function testTokenUsingGet(options?: { [key: string]: any }) {
  return request<STearAPI.ResponseDataMapStringObject>(
    "/smart-tea/v1.0/auth/sa/test-token",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
